<template>
  <div class="admin layout is-flex">
    <div
      id="appMenuContainer"
      ref="appMenuContainer"
      class="is-hidden-touch"
    >
      <div class="logo-container is-flex is-centered is-flex-direction-column">
        <img
          class="logo"
          :src="$store.state.ui.logo"
          alt="company logo"
        >
        <h1 class="title is-4 has-text-izzi-robins-egg-blue">
          factura electrónica
        </h1>
      </div>
      <div class="menu-container">
        <AppMenu class="sidebar navbar" />
      </div>
      <div class="separator" />
      <div
        v-show="false"
        class="notifications"
      >
        <AppButtonAddCiec />
        <AppButtonVerificationPending />
      </div>
    </div>

    <div class="is-flex main-container">
      <TheNavbar />
      <main>
        <RouterView />
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Admin',
  components: {
    TheNavbar: () => import(/* webpackChunkName: "the-navbar" */ '../../components/Admin/TheNavbar.vue'),
    AppMenu: () => import(/* webpackChunkName: "app-menu" */ '../../components/Admin/AppMenu.vue'),
    AppButtonVerificationPending: () => import(/* webpackChunkName: "app-button-verification-pending" */ '../../components/AppButtonVerificationPending.vue'),
    AppButtonAddCiec: () => import(/* webpackChunkName: "app-button-add-ciec" */ '../../components/AppButtonAddCIEC.vue'),
  },
  mounted() {
    window.inlineManualTracking = {
      uid: this.$store.state.auth.email,
      email: this.$store.state.auth.email,
    };

    if (typeof window.createInlineManualPlayer !== 'undefined') {
      window.createInlineManualPlayer(window.inlineManualPlayerData);
    }
  },
};
</script>

<style lang="scss" scoped>
#appMenuContainer {
  min-width: 265px;
  display: flex;
  flex-direction: column;
  background: $app-menu-background-color;
  height: 100vh;
  overflow: auto;
}

.separator {
  flex: 1;
}

.notifications {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 1.5rem;
  align-items: center;
}

.box .content {
  font-size: 1.25rem;
}

.logo-container {
  padding: 1rem 0;
}

.logo {
  width: 75%;
}

.main-container.is-flex {
  flex-direction: column;
  position: relative;
  flex: 1;
}

.main-container.is-flex main {
  height: calc(100vh - 3.25rem);
  width: calc(100vw - 265px);
  overflow: auto;
}

.has-text-izzi-robins-egg-blue {
  color: $izzi-robins-egg-blue;
}

.is-flex-direction-column {
  flex-direction: column;
}
</style>

<style>
@media screen and (max-width: 768px) {
  .main-container > main {
    width: 100%!important;
    padding-bottom: 5rem;
  }
}
</style>
